import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

function SnapShotDetails() {
  const { company_id, app_id, app_creator_app_id,planId,snapshot_ref_id } = useParams()
  const navigate = useNavigate()
// https://appcreator.alltheapps.io/app/DffIiKx29reKrz2Rd20w/683052a256e6dd0c2f4c2ba7/683e281148b9b55a91719f03/xNOGwivGVKqknfgdRTkI/snapshots-detail_iframe/68496d43c151b8688a971e3c
  // Construct iframe URL based on params (change domain/path as needed)
  const iframeUrl = `https://appcreator.alltheapps.io/snapshot/${company_id}/${app_id}/${planId}/snapshots-detail_iframe/${snapshot_ref_id}`
  
  return (
    <>
      <MDBox mb={2}>
        <MDButton
          variant="gradient"
          color="dark"
          sx={{ height: '100%' }}
          onClick={() => navigate(-1)}
        >
          Go Back
        </MDButton>
      </MDBox>
      <div>
        {/* <h1>Snap</h1>
        <p>All Service Stores</p> */}
        <iframe
          src={iframeUrl}
          title="Addons Iframe"
          style={{ width: '100%', height: '70vh', border: 'none' }}
        ></iframe>
      </div>
    </>
  )
}

export default SnapShotDetails
